import * as React from "react";
import { useAppSelector } from "../store/index";
import { RootState } from "../reducers/index";
import { selectCurrentPoi, selectMapDisplayMode } from "../reducers/poi";
import { IMapOptions } from "../interfaces/mapoptions";
import * as MapDisplayMode from "../constants/mapdisplaymode";

const HeaderSeo = () => {
    const mapoptions = useAppSelector<IMapOptions>((x: RootState) => x.mapoptions);
    const mapDisplayMode = useAppSelector<number>(selectMapDisplayMode);
    const poiData = useAppSelector(selectCurrentPoi);
    const locationName = useAppSelector<string>((x: RootState) => x.halfway.locationName);

    let halfwayAddress;
    if (locationName) {
        halfwayAddress = (<span>{locationName}.</span>);
    }
    else {
        halfwayAddress = (<span>Loading...</span>);
    }
    const isPoiMode = mapDisplayMode === MapDisplayMode.POI;
    if (isPoiMode && poiData) {
        return (
                <div className="top-data">
                    <i className="material-icons">near_me</i>
                    <h1><span>{poiData.result.name}</span> is near the halfway location between <span>{mapoptions.address1}</span> and <span>{mapoptions.address2}</span>.</h1>
                </div>
            );
    }
    else {
        return (
                <div className="top-data">
                    <i className="material-icons">layers</i>
                    <h1>The halfway point between <span>{mapoptions.address1}</span> and <span>{mapoptions.address2}</span> is: {halfwayAddress} Find a place to meet halfway.</h1>
                </div>
           );
    }
}


export default HeaderSeo;
